import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { AnalysisUI } from './models/AnalysesModel';

export default class DemetraAnalysesManagementVuexModule extends AbacoVuexModule {

    @State() curAnalysis!: AnalysisUI | null;

}

